import React, {useEffect, useMemo, useState} from 'react';

const Pagination = ({
                      showPerPage,
                      updatePageCount,
                      pageCount,
                      totalNumberOfItems
                    }) => {

  const [pagesList, pageListUpdate] = useState(null)
  const [showingNumber, showingNumberUpdate] = useState(null)

  const total = Math.ceil(totalNumberOfItems / showPerPage) - 1;

  const previous = () => {
    updatePageCount(pageCount - 1 > 0 ? pageCount - 1 : 0)
  };

  const next = () => {
    updatePageCount(pageCount + 1 < total ? pageCount + 1 : total)
  }

  const goto = (page) => {
    updatePageCount(page)
  }

  useMemo(() => {
    const cssCurrentPage = "z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
    const cssNotCurrentPage = "bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium"

    const start = Math.max(0, pageCount - 3);
    const end = Math.max(1, Math.min(total, start + 7));

    const list = [];

    if (start > 0) {
      list.push(<a
        key={pageCount + '-' + showPerPage + '-' + totalNumberOfItems + '-more_left'}
        href="#"
        aria-current="page"
        className={cssNotCurrentPage + " disabled"}
      >
        ...
      </a>)
    }

    for (let page = start; page < end; page++) {
      list.push(<a
        key={pageCount + '-' + showPerPage + '-' + totalNumberOfItems + '-' + page}
        href="#"
        onClick={() => goto(page)}
        aria-current="page"
        className={page === pageCount ? cssCurrentPage : cssNotCurrentPage}
      >
        {page + 1}
      </a>)
    }


    if (end !== total && total > 7) {
      list.push(<a
        key={pageCount + '-' + showPerPage + '-' + totalNumberOfItems + '-more_right'}
        href="#"
        aria-current="page"
        className={cssNotCurrentPage + " disabled"}
      >
        ...
      </a>)
    }

    pageListUpdate(list)
  }, [total, pageCount])

  useMemo(() => {
    showingNumberUpdate(<p className="text-sm text-gray-700">
      Showing <span className="font-medium">{pageCount
      * showPerPage}</span> to <span
      className="font-medium">{Math.min(totalNumberOfItems, (pageCount + 1) * showPerPage)}</span> of{' '}
      <span className="font-medium">{totalNumberOfItems}</span> results
    </p>)
  }, [total, pageCount, totalNumberOfItems])

  return (
    <div
      className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
      <div className="flex-1 flex justify-between sm:hidden">
        <a onClick={previous}
           href="#"
           className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
        >
          Previous
        </a>
        <a
          onClick={next}
          href="#"
          className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
        >
          Next
        </a>
      </div>
      <div
        className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
        <div>
          {showingNumber}
        </div>
        <div>
          <nav
            className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
            aria-label="Pagination">
            <a
              onClick={previous}
              href="#"
              className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
            >
              <span className="sr-only">Previous</span>
              <span className="fa-solid fa-chevron-left h-5 w-5"
                    aria-hidden="true"/>
            </a>
            {/* Current: "z-10 bg-indigo-50 border-indigo-500 text-indigo-600", Default: "bg-white border-gray-300 text-gray-500 hover:bg-gray-50" */}
            {pagesList}
            <a
              onClick={next}
              href="#"
              className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
            >
              <span className="sr-only">Next</span>
              <span className="fa-solid fa-chevron-right h-5 w-5"
                    aria-hidden="true"/>
            </a>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
